import { GrantAccess } from 'components/GrantAccess';
import { PermissionsEnum } from 'model/User';
import { WorkflowsList } from 'screens/WorkflowsScreen/WorkflowsList';

export default function WorkflowsListPage() {
  return (
    <GrantAccess permissionsNeeded={PermissionsEnum.RUN_RESOURCES}>
      <WorkflowsList />
    </GrantAccess>
  );
}
